import type { ContactNoteType } from '@/api/entity_types/ContactNote';

export const noteTypeOptions = ['General note', 'Log a call', 'Log an email', 'Log a text'] as const;

export type NoteTypeOption = (typeof noteTypeOptions)[number];

const noteTypeMap = new Map<NoteTypeOption, ContactNoteType>([
  ['General note', 'general'],
  ['Log a call', 'call'],
  ['Log a text', 'text'],
  ['Log an email', 'email'],
]);

export const getNoteType = (option: NoteTypeOption): ContactNoteType => {
  return noteTypeMap.get(option) ?? 'general';
};
